export class Fleet {
  fleetModelCode: string;
  averageDelayCost: number;
  averageDelayMinutes: number;
}
